/* eslint-disable no-console */
import { isDev, isProd } from 'constants/constants';

/**
 * Shows warning message in console when condition not met
 */
const devWarning = (
  /**
   * If condition not valid, shows warning
   */
  valid: boolean,
  component: string,
  message: string,
  enable?: boolean
): void => {
  if ((isDev || enable) && !valid) {
    console.warn(`Warning: [web-app: ${component}] ${message}`);
  }
};

/**
 * Shows error message when condition not met
 */
const devError = (
  /**
   * If condition not valid, shows warning
   */
  valid: boolean,
  component: string,
  message: string,
  enable?: boolean
): void => {
  if ((isDev || enable) && !valid) {
    console.error(`Error: [web-app: ${component}] ${message}`);
  }
};

/**
 * Logs message when condition not met
 */
const devLogger = (
  /**
   * If condition not valid, shows warning
   */
  valid: boolean,
  component: string,
  message: string,
  enable?: boolean
): void => {
  if ((isDev || enable) && !valid) {
    console.log(`Log: [web-app: ${component}] ${message}`);
  }
};

const devOnlyErrorLogger = (...rest) => {
  // used isProd to log errors for all envs except prod, beta
  // isLocalhost to log errors for all envs if running locally
  const isLocalhost = window.location.hostname === 'localhost';
  if (!isProd || isLocalhost) console.error(...rest);
};

export { devWarning, devError, devLogger, devOnlyErrorLogger };
